import { Outlet, useLocation } from "react-router-dom";
import LoginBackgroundCarousel from "./LoginBackgroundCarousel";

const SILK_BG =
  "https://images.unsplash.com/photo-1707573090905-8465126a393e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwcmVkJTIwYWJzdHJhY3QlMjBzaWxrJTIwdGV4dHVyZXxlbnwwfHx8fDE3Nzc1NDMyNjF8MA&ixlib=rb-4.1.0&q=85";

export default function AuthLayout() {
  const { pathname } = useLocation();
  const isAuthCard = pathname === "/auth";

  const silkOpacity = isAuthCard ? "opacity-[0.28]" : "opacity-50";
  const gradientOverlay = isAuthCard
    ? "radial-gradient(ellipse at top, rgba(139,30,63,0.12), transparent 58%), linear-gradient(180deg, rgba(5,5,5,0.32), rgba(5,5,5,0.78))"
    : "radial-gradient(ellipse at top, rgba(139,30,63,0.18), transparent 55%), linear-gradient(180deg, rgba(5,5,5,0.55), rgba(5,5,5,0.96))";
  const noiseOpacity = isAuthCard ? "opacity-25" : "opacity-40";

  return (
    <div className="relative h-[100dvh] w-full overflow-x-hidden overflow-y-auto bg-[#050505] text-[#f5f5f5]">
      {isAuthCard ? (
        <div className="absolute inset-0 z-[1]">
          <LoginBackgroundCarousel />
        </div>
      ) : null}

      {/* Sensual silk backdrop (más transparente en login para ver el carrusel) */}
      <div
        className={`absolute inset-0 z-[2] ${silkOpacity}`}
        style={{
          backgroundImage: `url(${SILK_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(2px) saturate(85%)",
        }}
        aria-hidden
      />
      <div
        className="absolute inset-0 z-[3]"
        style={{
          background: gradientOverlay,
        }}
        aria-hidden
      />
      <div
        className={`absolute inset-0 z-[4] pointer-events-none mix-blend-overlay ${noiseOpacity}`}
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.35'/></svg>\")",
        }}
        aria-hidden
      />

      <main className="relative z-10 flex min-h-full items-center justify-center px-6 py-6 md:py-8">
        <div className="w-full max-w-md zx-page-enter" data-testid="auth-shell">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
